import { useMemo } from "react";

export default function usePagination(data = [], itemsPerPage = 10, page = 1) {
  const count = Math.ceil(data.length / itemsPerPage);

  const slicedData = useMemo(() => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, page, itemsPerPage]);

  return { count, slicedData };
}
